/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Newsletter_DescriptionInputs */

const en_home_newsletter_description = /** @type {(inputs: Home_Newsletter_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign up to our newsletter and receive updates about how to support our movement.`)
};

/**
* | output |
* | --- |
* | "Sign up to our newsletter and receive updates about how to support our movement." |
*
* @param {Home_Newsletter_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_newsletter_description = /** @type {((inputs?: Home_Newsletter_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Newsletter_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_newsletter_description(inputs)
});